import request from '@/api'

import cacheData from './CacheData'

const server = '/Analysis'

/**
 *
 * @param {行业能力圈} params
 *  { flag: 1, code: 240001, manager_name: '汤慧', data_type: 'return', industry_name;'食品饮料' }
 * @returns
 */

export function getIndustryAbilityPerformance(params) {
    return request({
        url: server + '/IndustryAbilityPerformance/',
        method: 'get',
        params,
    })
}

/**
 *
 * @param {行业配置表现} params
 *  { flag: 2, code: this.manager_code, type: 'activeequity', industry_section: '申万(2021)' }
 * @returns
 */

export function getIndustryInfo(params) {
    return request({
        url: server + '/IndustryInfo/',
        method: 'get',
        params,
    })
    return cacheData.industryInfo
}
/**
 *
 * @param {行业评价数据} params
 *  /IndustryAppraise/?flag=1&code=110022&type=equity&feature_flag=1
 * @returns
 */

export function getIndustryDetlaCapability(params) {
    return request({
        url: server + '/IndustryAppraise/',
        method: 'get',
        params,
    })
    return cacheData.IndustryAppraise
}
// IndustryProfitDistribution
/**
 *
 * @param {行业收益统计} params
 *  /IndustryProfitDistribution/?flag=1&code=110022&type=equity&manager_name=&industry_code&data_type
 * @returns
 */

export function getIndustryProfitDistribution(params) {
    return request({
        url: server + '/IndustryProfitDistribution/',
        method: 'get',
        params,
    })
}
/**
 *
 * @param {长期持有个股} params
 * /StocksLongHold/?flag=1&code=110022&type=equity
 * @returns
 */

export function getStocksLongHold(params) {
    return request({
        url: server + '/StocksLongHold/',
        method: 'get',
        params,
    })
    return cacheData.stockLongHold
}

/**
 * 
 * @param {收益曲线} params 
 *  code: str (基金 基金经理 基金公司代码)
    flag: int (是否为基金 基金经理基金公司)
        1: fund
        2: manager
        3: company
    type: str(类型)
    start_date: date (起始时间)
    end_date: date (截止时间)
    benchmark: list (基准, 特殊基准见备注)
 * @returns 
 */

// 获取基金/基金经理/基金公司收益曲线
export function getRateInfo(data) {
    return request({
        url: server + '/RateInfo/',
        method: 'post',
        data,
    })
}
/**
 *
 * @param {长期持有个股-基金个股详情} params
 * stock_code='  '&code='   '&type
 * @returns
 */

export function getStocksDetail(params) {
    return request({
        url: server + '/StockInfo/',
        method: 'get',
        params,
    })
}
/**
 *
 * @param {买入卖出模式} params
 * /BuyOrSellModInfo/?flag=1&type=equity&code=000001&start_date=&end_date=&status=buy
 * status = buy (买入模式)
 * status = sell (卖出模式)
 * @returns
 */
export function getBuyOrSellModInfo(params) {
    return request({
        url: server + '/BuyOrSellModInfo/',
        method: 'get',
        params,
    })
    return cacheData.BuyOrSellMode
}
/**
 *
 * @param {大类资产配置} params
 * /AllocationDetails/?flag=1&type=equity&code=000001&start_date=&end_date=
 * @returns
 */
export function getAllocationDetails(params) {
    return request({
        url: server + '/AllocationDetails/',
        method: 'get',
        params,
    })
    return cacheData.AllocationDetail
}
// 获取基金收益曲线基准列表
export function getBenchmarkList(params) {
    return request({
        url: server + '/BenchmarkList/',
        method: 'get',
        params,
    })
}
/**
 *
 * @param {固收PLUS} params
 * @returns
 */
export function getCbondReturns(params) {
    return request({
        url: server + '/CbondReturns/',
        method: 'get',
        params,
    })
    return cacheData.CbondReturn
}
/**
 *
 * @param {转债季度信息} params
 * @returns
 */
export function getBondQuarterInfo(params) {
    return request({
        url: server + '/BondQuarterInfo/',
        method: 'get',
        params,
    })
    return cacheData.BondQuarterInfo
}
/**
 *
 * @param {获取行业仓位与收益} params
 * code=&manager_name=&industry_name=&start_date&end_date
 * @returns
 */
export function getIndustryWeightAndReturn(params) {
    return request({
        url: server + '/IndustryWeightAndReturn/',
        method: 'get',
        params,
    })
}
/**
 *
 * @param {获取行业超额收益统计} params
 * code=&manager_name=&industry_name=&start_date&end_date
 * @returns
 */
export function getIndustryExcessReturnDistribution(params) {
    return request({
        url: server + '/IndustryExcessReturnDistribution/',
        method: 'get',
        params,
    })
}
/**
 *
 * @param {券种配置} params
 * code=&type=&flag=
 * @returns
 */
export function getBondClassDetails(params) {
    return request({
        url: server + '/BondClassDetails/',
        method: 'get',
        params,
    })
}
